import React, { Component } from 'react';
import { Link, withRouter } from 'react-router';
import classNames from 'classnames';
import { Field, FieldArray, reset } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, Button, DropdownButton, MenuItem, FieldGroup, Input,  Breadcrumb } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Selection from '../Common/selection';
import InputField from '../Common/inputField';
import IsActive from '../Common/isActive';
import Spinner from '../Widgets/spinner';
import PaymentTermForm from '../../containers/Customers/paymentTermForm';
import { Translate, Localize } from 'react-redux-i18n';
import {isOLG} from '../../actions/root_url'

// Helping function to render a multi-fields form. Reference on redux-form array.

const renderShippingAddresses = ({ fields }) => (
    <Row><Col sm={ 12 }>
        <Row><Col sm={ 12 }>
            <Button type="button" className="btn btn-green btn-green-default" onClick={() => {
                fields.push({})   // pushes empty child field onto the end of the array
            } }><i/> <Translate value="add_shipping_address" />
            </Button>
        </Col></Row>
        <Row><Col sm={ 12 }>
            {!fields.length && <div className="marginTopStyle"><Translate value="no_shipping_address" /></div>}
            {fields.map((ShippingAddress, index) =>
                <Row key={index}>
                    <Col sm={ 12 }>
                        <Row className="marginTopStyle">
                            <label className="col-sm-5"><Translate value="shipping_address_poundsign" />{index + 1}</label>
                            <Button className="col-sm-3 btn btn-warning" type="button" onClick={() => {
                                fields.remove(index)  // remove from index
                            } }><i/> <Translate value="remove" />
                            </Button>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="address" />: </Col>
                            <Col sm={ 8 }><Field name={`${ShippingAddress}.Name`} component={ InputField } /></Col>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="street" />: </Col>
                            <Col sm={ 8 }><Field name={`${ShippingAddress}.Street`} component={ InputField } /></Col>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="state" />: </Col>
                            <Col sm={ 2 }><Field name={`${ShippingAddress}.State`} component={ InputField } /></Col>
                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="city" />: </Col>
                            <Col sm={ 2 }><Field name={`${ShippingAddress}.City`} component={ InputField } /></Col>
                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="zip" />: </Col>
                            <Col sm={ 2 }><Field name={`${ShippingAddress}.Zip`} component={ InputField } /></Col>
                        </Row>
                    </Col>
                </Row>) }
        </Col></Row>
    </Col></Row>
)

const renderShippingContacts = ({ fields }) => (
    <Row><Col sm={ 12 }>
        <Row><Col sm={ 12 }>
            <Button type="button" className="btn btn-green btn-green-default" onClick={() => {
                fields.push({})   // pushes empty child field onto the end of the array
            } }><i/> <Translate value="add_pickup" />
            </Button>
        </Col></Row>
        <Row><Col sm={ 12 }>
            {!fields.length && <div className="marginTopStyle"><Translate value="no_pickup" /></div>}
            {fields.map((ShippingContact, index) =>
                <Row key={index}>
                    <Col sm={ 12 }>
                        <Row className="marginTopStyle">
                            <label className="col-sm-5"><Translate value="pickup_poundsign" />{index + 1}</label>
                            <Button className="col-sm-3 btn btn-warning" type="button" onClick={() => {
                                fields.remove(index)  // remove from index
                            } }><i/> <Translate value="remove" />
                            </Button>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="first_name" />: </Col>
                            <Col sm={ 2 }><Field name={`${ShippingContact}.FirstName`} component={ InputField } /></Col>
                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="last_name" />: </Col>
                            <Col sm={ 2 }><Field name={`${ShippingContact}.LastName`} component={ InputField } /></Col>
                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="middle_name" />: </Col>
                            <Col sm={ 2 }><Field name={`${ShippingContact}.MiddleName`} component={ InputField } /></Col>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" >Tel: </Col>
                            <Col sm={ 6 }><Field name={`${ShippingContact}.Telephone`} component={ InputField } /></Col>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" >Fax: </Col>
                            <Col sm={ 6 }><Field name={`${ShippingContact}.Fax`} component={ InputField } /></Col>
                        </Row>
                        <Row className="marginTopStyle">
                            <Col sm={ 2 } className="marginTopStyle" >E-mail: </Col>
                            <Col sm={ 6 }><Field name={`${ShippingContact}.Email`} component={ InputField } /></Col>
                        </Row>
                    </Col>
                </Row>) }
        </Col></Row>
    </Col></Row>
)

class AgentForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            paymentTermOpen: false,
            dirty: false
        };
        this.openPaymentTerm = this.openPaymentTerm.bind(this);
        this.closePaymentTerm = this.closePaymentTerm.bind(this);
    }

    componentWillMount() {
        reset('productForm');
    }

    componentDidMount() {
        const { currentAgent } = this.props;
        if (currentAgent)
            this.props.fetchAgentDetail(currentAgent.Agent_id)
                .then(() => this.props.fetchPaymentTerms());
        else this.props.fetchPaymentTerms();
        // making a leaving hook to confirm leaving
        this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }

    componentDidUpdate() {
        reset('productForm');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dirty != this.props.dirty) {
            this.setState({
                dirty: nextProps.dirty
            });
        }
    }

    routerWillLeave(nextLocation) {
        if (this.state.dirty) return 'Your work is not saved! Are you sure you want to leave?'
    }

    // Helper function to pop up the add payment term function

    openPaymentTerm() { this.setState({ paymentTermOpen: true }); }

    closePaymentTerm() { this.setState({ paymentTermOpen: false }); }

    onSubmit(props) {
        if (!this.props.params.id) this.props.createProduct(props);
        else this.props.editProduct(props);
    }

    handleFormSubmit(formProps) {
        this.setState({ dirty: false });
        if (!this.props.currentAgent) this.props.createAgent(formProps);
        else {
          if(!this.checkPermission("change_agent"))
            this.props.editAgent(formProps);
          else
            alert("You have no permission!");
        }
    }

    title() {
        if (!this.props.params.id) {
          return <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="general_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Translate value="agent" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="create_a_new_agent" />
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        return <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Translate value="agent" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="edit_agent" />
          </Breadcrumb.Item>
        </Breadcrumb>
    }

    renderPaymentTerms() {
        if (this.props.paymentTermsIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
        else {
            let paymentTermOptions = this.getPaymentTermOptions();
            return (
                <Row>
                    <Col sm={ 8 }>
                        <Field name="PaymentTerm_id" component={Selection} options={paymentTermOptions}/>
                    </Col>
                    <Col sm={ 4 }>
                        <button className="btn btn-primary" onClick={() => { this.openPaymentTerm() } }><Translate value="add" /></button>
                    </Col>
                </Row>
            )
        }
    }

    getPaymentTermOptions() {
        var paymentTermOptions = [];
        this.props.paymentTerms.map(paymentTerm => {
            paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
        });
        return paymentTermOptions;
    }

    // In case we need the shipping information for Agent

    // <Panel header="Shipping Information">
    //     <FieldArray name="ShippingAddress" component={renderShippingAddresses} />
    //     <br/>
    //     <FieldArray name="ShippingContact" component={renderShippingContacts} />
    // </Panel>

    checkPermission(permission) {
        return false;
    }

    render() {
        const agentInformation = (<Translate value="agent_information" />);
        const activeCustomer = (<Translate value="active_customer" />);
        const billingInformation = (<Translate value="billing_information" />);
        const mailingInformation = (<Translate value="mailing_information" />);
        const addANewPaymentTerm = (<Translate value="add_a_new_payment_term" />);
        const { handleSubmit, submitting, pristine } = this.props;
        if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...<Translate value="reading_data" /></ContentWrapper>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            return (
                <ContentWrapper>
                    <h1>
                        {this.props.name}
                    </h1>
                    <Panel>
                        {this.title() }
                        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                            <hr/>
                            <Row>
                                <Col sm={ 6 }>
                                    <Panel header={agentInformation}>
                                        <Row>
                                            <Col sm={ 4 }>
                                                <div className="form-group">
                                                    <label><Translate value="agent_name" /></label>
                                                    <Field name="Name" component={ InputField } />
                                                </div>
                                            </Col>
                                            <Col sm={ 4 }>
                                                <div className="form-group">
                                                    <label><Translate value="agent_num" /></label>
                                                    <Field name="AgentNum" component={ InputField } />
                                                </div>
                                            </Col>
                                            <Col sm={ 4 }>
                                                <div className="form-group">
                                                    <label><Translate value={isOLG ? "item_no" : "ref_num"} /></label>
                                                    <Field name="RefNum" component={ InputField } />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={ 12 }>
                                                <div className="form-group">
                                                    <label><Translate value="description" /></label>
                                                    <Field name="Description" component={ InputField } />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={ 12 }>
                                                <div className="form-group">
                                                    <label><Translate value="credit_status" /></label>
                                                    <Field name="CreditStatus" component={ InputField } />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Field name="IsActive" labelName={activeCustomer} component={ IsActive } />
                                    </Panel>
                                    <Panel header={mailingInformation}>
                                        <Row>
                                            <Col sm={ 12 }>
                                                <div className="form-group">
                                                    <Row><Col sm={ 12 }>
                                                        <label><Translate value="mailing_address" /></label>
                                                    </Col></Row>
                                                    <Row className="marginTopStyle">
                                                        <Col sm={ 2 }><Translate value="name" />: </Col>
                                                        <Col sm={ 8 }><Field name="MailingAddress.Name" component={ InputField } /></Col>
                                                    </Row>
                                                    <Row className="marginTopStyle">
                                                        <Col sm={ 2 }><Translate value="street" />: </Col>
                                                        <Col sm={ 6 }><Field name="MailingAddress.Street" component={ InputField } /></Col>
                                                    </Row>
                                                    <Row className="marginTopStyle">
                                                        <Col sm={ 2 }><Translate value="state" />: </Col>
                                                        <Col sm={ 2 }><Field name="MailingAddress.State" component={ InputField } /></Col>
                                                        <Col sm={ 2 }><Translate value="city" />: </Col>
                                                        <Col sm={ 2 }><Field name="MailingAddress.City" component={ InputField } /></Col>
                                                        <Col sm={ 2 }><Translate value="zip" />: </Col>
                                                        <Col sm={ 2 }><Field name="MailingAddress.Zip" component={ InputField } /></Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row><Col sm={ 12 }>
                                            <label><Translate value="mailing_contact" /></label>
                                        </Col></Row>
                                        <Row>
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="first_name" />: </Col>
                                            <Col sm={ 2 }><Field name="MailingContact.FirstName" component={ InputField } /></Col>
                                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="last_name" />: </Col>
                                            <Col sm={ 2 }><Field name="MailingContact.LastName" component={ InputField } /></Col>
                                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="middle_name" />: </Col>
                                            <Col sm={ 2 }><Field name="MailingContact.MiddleName" component={ InputField } /></Col>
                                        </Row>
                                        <Row className="marginTopStyle">
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="tel" />: </Col>
                                            <Col sm={ 6 }><Field name="MailingContact.Telephone" component={ InputField } /></Col>
                                        </Row>
                                        <Row className="marginTopStyle">
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="fax" />: </Col>
                                            <Col sm={ 6 }><Field name="MailingContact.Fax" component={ InputField } /></Col>
                                        </Row>
                                        <Row className="marginTopStyle">
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="email" />: </Col>
                                            <Col sm={ 6 }><Field name="MailingContact.Email" component={ InputField } /></Col>
                                        </Row>
                                    </Panel>
                                </Col>
                                <Col sm={ 6 }>
                                    <Panel header={billingInformation}>
                                        <Row><Col sm={ 12 }>
                                            <Row><Col sm={ 12 }><label><Translate value="payment_term" /></label></Col></Row>
                                            { this.renderPaymentTerms() }
                                        </Col></Row>
                                        <br/>
                                        <Row>
                                            <Col sm={ 12 }>
                                                <div className="form-group">
                                                    <Row><Col sm={ 12 }>
                                                        <label><Translate value="billing_address" /></label>
                                                    </Col></Row>
                                                    <Row className="marginTopStyle">
                                                        <Col sm={ 2 }><Translate value="name" />: </Col>
                                                        <Col sm={ 8 }><Field name="BillingAddress.Name" component={ InputField } /></Col>
                                                    </Row>
                                                    <Row className="marginTopStyle">
                                                        <Col sm={ 2 }><Translate value="street" />: </Col>
                                                        <Col sm={ 6 }><Field name="BillingAddress.Street" component={ InputField } /></Col>
                                                    </Row>
                                                    <Row  className="marginTopStyle">
                                                        <Col sm={ 2 }><Translate value="state" />: </Col>
                                                        <Col sm={ 2 }><Field name="BillingAddress.State" component={ InputField } /></Col>
                                                        <Col sm={ 2 }><Translate value="city" />: </Col>
                                                        <Col sm={ 2 }><Field name="BillingAddress.City" component={ InputField } /></Col>
                                                        <Col sm={ 2 }><Translate value="zip" />: </Col>
                                                        <Col sm={ 2 }><Field name="BillingAddress.Zip" component={ InputField } /></Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row><Col sm={ 12 }>
                                            <label><Translate value="billing_contact" /></label>
                                        </Col></Row>
                                        <Row>
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="first_name" />: </Col>
                                            <Col sm={ 2 }><Field name="BillingContact.FirstName" component={ InputField } /></Col>
                                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="last_name" />: </Col>
                                            <Col sm={ 2 }><Field name="BillingContact.LastName" component={ InputField } /></Col>
                                            <Col sm={ 2 }  className="marginTopStyle" ><Translate value="middle_name" />: </Col>
                                            <Col sm={ 2 }><Field name="BillingContact.MiddleName" component={ InputField } /></Col>
                                        </Row>
                                        <Row className="marginTopStyle">
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="tel_colonsign" /> </Col>
                                            <Col sm={ 6 }><Field name="BillingContact.Telephone" component={ InputField } /></Col>
                                        </Row>
                                        <Row className="marginTopStyle">
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="fax_colonsign" /> </Col>
                                            <Col sm={ 6 }><Field name="BillingContact.Fax" component={ InputField } /></Col>
                                        </Row>
                                        <Row className="marginTopStyle">
                                            <Col sm={ 2 } className="marginTopStyle" ><Translate value="email_colonsign" /> </Col>
                                            <Col sm={ 6 }><Field name="BillingContact.Email" component={ InputField } /></Col>
                                        </Row>
                                    </Panel>
                                </Col>
                            </Row>
                            <Row>
                            </Row>
                            <button action="submit" className="btn btn-primary" disabled={ submitting || pristine }><Translate value="submit" /></button>
                            <Link to="/agents" className="btn btn-danger buttonStyle"><Translate value="cancel" /></Link>
                            { this.props.isCreating || this.props.isEditing && <Spinner/> }
                            { this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> }
                            { this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> }
                        </form>
                        <SkyLightStateless isVisible={this.state.paymentTermOpen} onCloseClicked={() => { this.closePaymentTerm() } } title={addANewPaymentTerm}>
                            <PaymentTermForm closePT={this.closePaymentTerm} />
                        </SkyLightStateless>
                    </Panel>
                </ContentWrapper >
            )
        }
    }
}

export default withRouter(AgentForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Agents/agentForm.jsx